module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_3000_5000.95aaced8.png";